<template>
  <div class="top-five-banks p-3">
    <h4>Top 5 banks by reported amount in FinCEN Files</h4>
    <p class="mb-0">Total amount diclosed by banks in suspicious activity reports found in the FinCEN Files.</p>
    <stacked-bar-chart :data="data" x-axis-tick-format="$,.0f" label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Source: FinCEN Files data</p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network. The 1,750 SARs in this data cover transactions between 1999 and 2017.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'TopFiveBanks',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Deutsche Bank', value: 1310771379656 },
        { label: 'JPMorgan', value: 514206745666 },
        { label: 'Standard Chartered', value: 166139835277 },
        { label: 'Bank of New York Mellon', value: 64109417780 },
        { label: 'Barclays', value: 21677582233 }
      ]
    }
  }
}
</script>
